import Api from '../http.service';

/**get my point of sale
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.endDate
 * @param {String} payload.data.startDate
 * @param {Boolean} payload.data.isWithdraw
 */
export const getMySalePoint = (payload) =>
  Api.POST({
    url: `point_of_sale/me/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });

/**get business  point of sale
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 */

export const getBusinessSalePoint = (payload) =>
  Api.GET({
    url: `point_of_sale/business/${payload.profileId}/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });
